import React from "react";
import { useTranslation } from "react-i18next";
import { Header } from "../components/shared";
import { CheckoutFooter } from "../components/checkout";
import "../styles/legal/LegalPages.css";

const PrivacyPolicy = () => {
  const { t } = useTranslation("legal");

  return (
    <div className="privacy-policy-page">
      <Header />
      <div className="privacy-policy-container">
        <div className="privacy-policy-content">
          <h1 className="privacy-policy-title">{t("privacyPolicy.title")}</h1>
          <p className="privacy-policy-last-updated">{t("privacyPolicy.lastUpdated")}</p>

          {/* Introduction */}
          <section className="privacy-section">
            <h2>{t("privacyPolicy.introduction.title")}</h2>
            <p>{t("privacyPolicy.introduction.content")}</p>
          </section>

          {/* Information We Collect */}
          <section className="privacy-section">
            <h2>{t("privacyPolicy.informationWeCollect.title")}</h2>

            <h3>{t("privacyPolicy.informationWeCollect.personalInfo.title")}</h3>
            <p>{t("privacyPolicy.informationWeCollect.personalInfo.description")}</p>
            <ul>
              {t("privacyPolicy.informationWeCollect.personalInfo.items", { returnObjects: true }).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            <p>{t("privacyPolicy.informationWeCollect.personalInfo.consent")}</p>

            <h3>{t("privacyPolicy.informationWeCollect.automaticInfo.title")}</h3>
            <p>{t("privacyPolicy.informationWeCollect.automaticInfo.description")}</p>
            <ul>
              {t("privacyPolicy.informationWeCollect.automaticInfo.items", { returnObjects: true }).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>

            <h3>{t("privacyPolicy.informationWeCollect.googleData.title")}</h3>
            <p>{t("privacyPolicy.informationWeCollect.googleData.description")}</p>
            <ul>
              {t("privacyPolicy.informationWeCollect.googleData.items", { returnObjects: true }).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          {/* How We Use Your Information */}
          <section className="privacy-section">
            <h2>{t("privacyPolicy.howWeUse.title")}</h2>
            <p>{t("privacyPolicy.howWeUse.description")}</p>
            <ul>
              {t("privacyPolicy.howWeUse.items", { returnObjects: true }).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          {/* Remarketing and Advertising */}
          <section className="privacy-section">
            <h2>{t("privacyPolicy.remarketing.title")}</h2>
            <p>{t("privacyPolicy.remarketing.content")}</p>
            <p>{t("privacyPolicy.remarketing.optOut")}</p>
          </section>

          {/* Sharing Your Information */}
          <section className="privacy-section">
            <h2>{t("privacyPolicy.sharing.title")}</h2>
            <p>{t("privacyPolicy.sharing.description")}</p>
            <ul>
              {t("privacyPolicy.sharing.items", { returnObjects: true }).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          {/* Data Security */}
          <section className="privacy-section">
            <h2>{t("privacyPolicy.security.title")}</h2>
            <p>{t("privacyPolicy.security.content")}</p>
          </section>

          {/* Your Choices */}
          <section className="privacy-section">
            <h2>{t("privacyPolicy.yourChoices.title")}</h2>

            <h3>{t("privacyPolicy.yourChoices.optOut.title")}</h3>
            <p>{t("privacyPolicy.yourChoices.optOut.content")}</p>

            <h3>{t("privacyPolicy.yourChoices.gdprRights.title")}</h3>
            <p>{t("privacyPolicy.yourChoices.gdprRights.description")}</p>
            <p>{t("privacyPolicy.yourChoices.gdprRights.dataRequest")}</p>
            <p><strong>{t("privacyPolicy.yourChoices.gdprRights.rightsTitle")}</strong></p>
            <ul>
              {t("privacyPolicy.yourChoices.gdprRights.rights", { returnObjects: true }).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          {/* Cookies */}
          <section className="privacy-section">
            <h2>{t("privacyPolicy.cookies.title")}</h2>
            <p>
              {t("privacyPolicy.cookies.content")}{" "}
              <a href="/cookie-policy" className="privacy-link">Cookie Policy</a>.
            </p>
          </section>

          {/* Changes to This Privacy Policy */}
          <section className="privacy-section">
            <h2>{t("privacyPolicy.changes.title")}</h2>
            <p>{t("privacyPolicy.changes.content")}</p>
          </section>

          {/* Contact Us */}
          <section className="privacy-section">
            <h2>{t("privacyPolicy.contact.title")}</h2>
            <p>{t("privacyPolicy.contact.description")}</p>
            <div className="contact-info">
              <p className="contact-info-title">{t("contact.companyName")}</p>
              <div className="contact-info-grid">
                <p className="contact-info-item">
                  <span className="label">Email:</span> info@suncatchers.pt
                </p>
                <p className="contact-info-item">
                  <span className="label">Phone:</span> +351 925 025 908{" "}
                  <span className="contact-phone-note">({t("contact.phoneNote")})</span>
                </p>
                <p className="contact-info-item full-width">
                  <span className="label">Address:</span> Av. Pedro Álvares Cabral 147, Linhó, 2710-144 Sintra
                </p>
              </div>
            </div>
            <p><em>{t("privacyPolicy.contact.acknowledgment")}</em></p>
          </section>
        </div>
      </div>
      <CheckoutFooter />
    </div>
  );
};

export default PrivacyPolicy;
